import { cartTotalDisplayStyles } from "@bevco/Overrides/Components/CartTotalDisplay";
import { colorStrings } from "@bevco/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartTotalDisplayStyles.totalWrapper = {
    css: css`
        border-top: 1px solid ${getColor(colorStrings.commonBorder)};
        width: 100%;
        display: flex;
        margin-top: 8px;
    `,
};
